<div class="bmc-syncdata-export-step40">
    <label class="bmc-syncdata-export-step40__higher-text">{{ 'SYNC_DATA.EXPORT_FINISHED' | translate}}</label>
    <label class="bmc-syncdata-export-step40__lower-text">{{ 'SYNC_DATA.DATA_EXPORTED' | translate}}</label>
</div> 
